// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2pNTd","consentsList":"PatientConsents_consentsList__2hJys","consentsListEmpty":"PatientConsents_consentsListEmpty__2LMcV"};